import { useNavigation } from 'react-router';
import { Spinner } from '../../public/site/siteUtils';

import './DataLoaderSpinner.scss';

export const DataLoaderSpinner = () =>
  useNavigation().state === 'loading' ? (
    <div className="of-data-loader-spinner">
      <div className="of-data-loader-spinner-backdrop" role="presentation" />
      <div className="spinner-wrapper">
        <Spinner />
      </div>
    </div>
  ) : (
    <></>
  );
